import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './core/auth/auth.guard';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AppRoute } from './app-routing.models';

const mainRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule),
        canActivate: [AuthGuard],
        canLoad: [AuthGuard]
    }
];

export const routes: Routes = [
    {
        path: AppRoute.LOGIN,
        component: LoginComponent,
        canActivate: [AuthGuard]
    },
    {
        path: AppRoute.FORGOT_PASSWORD,
        component: ForgotPasswordComponent,
        canActivate: [AuthGuard]
    },
    {
        path: `${AppRoute.CREATE_NEW_PASSWORD}/:uniqueToken`,
        component: ResetPasswordComponent,
        canActivate: [AuthGuard]
    },
    ...mainRoutes,
    // otherwise redirect to home
    { path: '**', redirectTo: 'login' }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, { enableTracing: false });
